import * as React from 'react';
import { getClassName } from '../../util/string-util';
import './Panel.scss';

export const Panel: React.SFC<IPanelProps> = ({ type, className, ...props }) => (
  <div className={getClassName('panel', className, type)} {...props} />
);

interface IPanelProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  type?: 'error' | 'info';
}



// WEBPACK FOOTER //
// ./src/components/Panel/Panel.tsx